import { Pipe, PipeTransform } from '@angular/core';
import { MvpExpertType } from '../models/mvp-experts.models';

const MVP_EXPERT_TYPE_LABELS: Record<MvpExpertType, string> = {
  sms: 'SMS',
  rolodex: 'Panel',
};

const MVP_EXPERT_TYPE_TOOLTIPS: Record<MvpExpertType, string> = {
  sms: 'Has opted into SMS messages',
  rolodex: 'Belongs to a panel',
};

@Pipe({
  name: 'mvpExpertType',
})
export class MvpExpertTypePipe implements PipeTransform {
  transform(type: MvpExpertType): string {
    return MVP_EXPERT_TYPE_LABELS[type] ?? type;
  }
}

@Pipe({
  name: 'mvpExpertTypeTooltip',
})
export class MvpExpertTypeTooltipPipe implements PipeTransform {
  transform(type: MvpExpertType): string {
    return MVP_EXPERT_TYPE_TOOLTIPS[type] ?? type;
  }
}
